module.exports = __webpack_public_path__ + "media/LULUU_video.eca269b8.mp4";